var exports = {
  "y": "AutocompleteMention.module__divider___dDJuUU",
};

module.exports = exports;
